import {ReactElement, useEffect, useState} from "react";
import {ThemeProvider} from "styled-components";
import {ViziblyTheme} from "../styles/zendesk-garden/ViziblyZDGTheme";
import useAppStore from "../hooks/useAppStore";
import VZThinking from "../components/vz-ui/vz-thinking/VZThinking";
import {Button} from "@zendeskgarden/react-buttons";

export function FunPlayground(): ReactElement {
    const appStore = useAppStore();
    const [resetKey, setResetKey] = useState<number>(1);

    useEffect(() => {
        appStore.set({ isLoading: false });
    }, []);

    const stepsTest = [];
    for (let i = 0; i < 3; i++) {
        stepsTest.push(
            {
                title: "Checking Property",
                durationMs: 2000,
                completedSubtitle: "Bowman Estates verified.",
            },
            {
                title: "AI Analyzing GL Accounts for driver recommendations",
                durationMs: 2200,
                substeps: ["substep 1", "substep 2", "substep 3", "substep 4", "substep 5", "substep 6"],
                run: () => Promise.resolve("Example executing a promise for a step"),
            },
        );
    }

    return (
        <ThemeProvider theme={ViziblyTheme}>
            <div style={{marginTop: "75px", padding: "2rem"}}>

                <div>
                    <h4 style={{borderBottom: "1px solid #aaaaaa", paddingBottom: ".5rem", marginBottom: "1rem"}}>Thinking Component</h4>
                    <div style={{marginBottom: "20px"}}>
                        <Button onClick={() => setResetKey(resetKey + 1)}>Reset Thinking</Button>
                    </div>
                    <div key={resetKey} style={{padding: "20px", maxWidth: "500px"}}>
                        <VZThinking
                            completedTitle="Driver recommendations ready"
                            onComplete={() => {
                                console.log("thinking complete!");
                            }}
                            steps={stepsTest}
                        />
                    </div>
                </div>

                <div>
                    <h4 style={{borderBottom: "1px solid #aaaaaa", paddingBottom: ".5rem", marginBottom: "1rem"}}>FlappyViz</h4>
                    {/* <FlappyViz /> */}
                </div>

            </div>
        </ThemeProvider>
    );
}
